import { MessageBox } from 'element-ui';
import { contact } from '@/api';

const checkConflict = async ({ class_id, contact_ids }) => {
  const res = await contact.checkClassTimeConflict({
    params: {
      class_id,
      contact_ids
    }
  });
  if (!res || !res.data) return false;
  if (!res.data.is_class_time_conflict) return true;
  try {
    const confirm = await MessageBox.confirm('学员上课时间冲突，是否继续报名？', '提示', {
      type: 'warning',
      confirmButtonText: '继续',
      cancelButtonText: '取消'
    });
    if (confirm !== 'confirm') return false;
  } catch (error) {
    return false;
  }
  return true;
};
export default checkConflict;
